<template>
  <el-dialog title="修改技师" :visible.sync="dialogVisible" @close="quxiao"
    width="900px">
	<!-- <el-input class="mb16" v-model="uses" size="small"  placeholder="请输入要修改的技师"></el-input> -->
	<el-select  v-model="getDate" placeholder="区" width="400px">
	  <el-option :label="item.name" 
	    v-for="(item,index) in getDate[username]"
	    :key='index2'></el-option>
	</el-select>
	<div slot="footer" class="dialog-footer">
	  <el-button @click="quxiao">取 消</el-button>
	  <el-button type="primary" @click="addUser">确 定</el-button>
	</div>
  </el-dialog>
</template>

<script>
  // import OrderApi from '@/api/order.js';
  // import DataApi from '@/api/data.js';
  import Technician from '@/api/technician.js'
  export default {
    data() {
      return {
		  // 技师输入框
		uses:'',
        /*是否显示*/
        dialogVisible: false,
        /*结果类别*/
        type: 'error',
		user_id:'',
		user_ids:'',
		// 所有技师
		getDate:[],
		
      }
    },
    props: ['isModify'],
    watch: {
      isModify: function(n) {
		  console.log(n,'chaksnhu')
		   this.dialogVisible = n;
		   this.getwait()
      },
    },
	created() {
		console.log('chakanshuju')
		console.log(this.$refs,'sssh')
		this.getwait()
	},
    mounted() {
    },
    methods: {
		// 查询所有技师
		getwait(){
			console.log('222')
			let self = this
			Technician.getWaiter({},true)
				.then(data => {
					self.getDate = data.data.Waiter
					console.log(self.getDate)
				})
				.catch(error => {
					self.loading = false;
				});
		},
	  quxiao(){
		console.log('22')
	  	this.$emit('closeDialog', {
	  	  type: 'success',
	  	  openDialog: false
	  	})
	  },
	  // 确定
	  addUser(){
		  let self = this
		  self.$emit('closeDialog', {
		    type: 'success',
		    openDialog: false
		  })
		  let waiter_user_id = self.user_id
		  let user_id = self.user_ids
		  Technician.updateWaiterUserId({
		  			waiter_user_id,
					user_id
		  		},
		  		true
		  	)
		  	.then(data => {
		  		console.log(self.use)
		  	})
		  	.catch(error => {
		  		self.loading = false;
		  	});
	  }
    }
  }
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/order/order/modify.vue